import { Link } from "react-router-dom";

const A = "/brand";
const btnGhostTeal =
  "inline-flex items-center justify-center gap-2 border border-[#159E9A]/60 text-[#159E9A] rounded-[10px] px-6 py-3 text-sm font-medium hover:bg-[#159E9A] hover:text-white transition-colors";

const titles = [
  { title: "The Word You Carry", img: `${A}/blueprint4joy-book-the-word-you-carry.jpg`, buyUrl: "https://a.co/d/0bbwrBCu" },
  { title: "Chasing Fireflies", img: `${A}/blueprint4joy-book-chasing-fireflies.jpg`, buyUrl: "https://a.co/d/0dvpob89" },
  { title: "The Forgotten Song", img: `${A}/blueprint4joy-book-the-forgotten-song.jpg` },
  { title: "Built For The Night", img: `${A}/blueprint4joy-book-built-for-the-night.jpg` },
];

export function Books() {
  return (
    <section
      data-testid="books-section"
      className="relative overflow-hidden"
      style={{ background: "linear-gradient(180deg, #F8F7F5 0%, #FAFAF8 50%, #FFFFFF 100%)" }}
    >
      <div
        aria-hidden
        className="absolute top-1/4 left-0 w-[500px] h-[500px] opacity-[0.02]"
        style={{ background: "radial-gradient(circle, #F6A041 0%, transparent 70%)" }}
      />
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-6 md:pt-8 pb-12 md:pb-14 relative z-[1]">
        <div className="max-w-3xl mb-10 reveal">
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.08] tracking-tight text-[#1C1917]">
            Books That Build the Blueprint
          </h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-8 gap-y-12">
          {titles.map((b, i) => (
            <article key={i} data-testid={`book-${i}`} className="reveal group">
              <div className="aspect-[3/4] overflow-hidden bg-white relative shadow-sm">
                <img
                  src={b.img}
                  alt={b.title}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.05]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1C1917]/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                {b.buyUrl && (
                  <a
                    href={b.buyUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`book-buy-link-${i}`}
                    className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                  >
                    <span className="inline-flex items-center gap-2 bg-[#FF5A4F] text-white rounded-full px-5 py-2 text-sm font-medium shadow-md hover:bg-[#e8463c] transition-colors">
                      Buy Now
                    </span>
                  </a>
                )}
              </div>
              <p className="mt-5 font-display text-lg text-[#1C1917]">{b.title}</p>
            </article>
          ))}
        </div>
        <div className="mt-12 reveal">
          <Link to="/books" data-testid="books-cta" className={btnGhostTeal}>
            Explore the Books →
          </Link>
        </div>
      </div>
    </section>
  );
}
